"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
function DesktopMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="hidden md:flex gap-6">
        <div className="h-6 w-16 bg-muted animate-pulse" />
        <div className="h-6 w-20 bg-muted animate-pulse" />
        <div className="h-6 w-24 bg-muted animate-pulse" />
      </div>;
  }
  const filteredItems = menuItems.filter(item => !(item.label === "Extragiudiziali" && item.href !== "/ExtrajudicialPage"));
  return <NavigationMenu viewport={false} className="hidden md:flex">
      <NavigationMenuList className="gap-6">
        <NavigationMenuItem className="flex flex-col mr-4">
          <span className="text-[#003366] font-default font-bold text-base leading-tight">
            World Immigration
          </span>
          <span className="text-[#003366]/70 text-xs font-medium">
            Visti Turistici e Consolari
          </span>
          <span className="text-xs text-[#003366]/60 mt-1">
            Aziende • Studenti • Professionisti • Dipendenti
          </span>
        </NavigationMenuItem>
        {filteredItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className={item.label === "Richiedi la tua pratica Online" ? "bg-[#FFC829] text-[#091221] px-4 py-2 rounded-lg font-default font-semibold text-base hover:bg-[#FFC829]/90 transition-all duration-300 shadow-md" : "text-[#003366] font-default font-semibold text-base hover:text-[#00F5FF] transition-all duration-300 relative after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-[#00F5FF] after:transition-all hover:after:w-full"}>
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuContent({
  onNavigate
}: {
  onNavigate: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4 py-4">
        <div className="h-10 w-full bg-muted animate-pulse" />
        <div className="h-10 w-full bg-muted animate-pulse" />
        <div className="h-10 w-full bg-muted animate-pulse" />
      </div>;
  }
  const filteredItems = menuItems.filter(item => !(item.label === "Extragiudiziali" && item.href !== "/ExtrajudicialPage"));
  return <div className="flex flex-col gap-4 py-4">
      <nav className="flex flex-col gap-2">
        <div className="px-0 py-2 mb-2 border-b border-[#003366]/10">
          <div className="text-[#003366] font-default font-bold text-xl">
            World Immigration
          </div>
          <div className="text-[#003366]/70 text-sm">
            Visti Turistici e Consolari
          </div>
          <div className="text-xs text-[#003366]/60 mt-1">
            Aziende • Studenti • Professionisti • Dipendenti
          </div>
        </div>
        {filteredItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className={item.label === "Richiedi la tua pratica Online" ? "bg-[#FFC829] text-[#091221] px-4 py-3 rounded-lg font-default font-semibold text-lg mt-2 text-center hover:bg-[#FFC829]/90 transition-colors duration-300 shadow-md" : "text-[#003366] font-default font-semibold text-lg py-3 border-b border-[#003366]/10 hover:text-[#00F5FF] transition-colors duration-300"} onClick={onNavigate} data-index={i}>
            {item.label}
          </Link>)}
      </nav>
    </div>;
}
export default function GatewayNavigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section data-section-id="224157" id="navigazione-corporate" className={`sticky top-0 z-[999] w-full transition-all duration-500 ${isScrolled ? "bg-white/90 backdrop-blur-[12px] border-b border-[#003366]/10 shadow-md h-24" : "bg-white border-b border-[#003366]/5 h-28"}`}>
      <MenuProvider menu_id="16" className="container mx-auto px-4 md:px-6 lg:px-8 h-full flex items-center justify-between">
        
        <div className="flex items-center gap-8">
          <DesktopMenu />
        </div>

        
        <Sheet open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon" className="text-[#003366]">
              <Menu className="size-6" />
              <span className="sr-only">Toggle navigation menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent side="top" className="w-full border-b border-[#003366]/10 bg-white">
            <MobileMenuContent onNavigate={() => setIsMobileMenuOpen(false)} />
          </SheetContent>
        </Sheet>
      </MenuProvider>
    </section>;
}